import { actually } from './logging';

export const retryPromise = <T>(fn: () => Promise<T>, retriesLeft = 3, interval = 200): Promise<T> => {
  return new Promise((resolve, reject) => {
    return fn()
      .then(resolve)
      .catch(error => {
        if (retriesLeft === 1) {
          reject(error);

          return;
        }

        setTimeout(() => {
          actually.debug('retriesLeft: ', retriesLeft);
          // Passing on "reject" is the important part
          retryPromise(fn, retriesLeft - 1, interval).then(resolve, reject);
        }, interval);
      });
  });
};
